import { ReverseProductUploadContext } from 'app/reverse-auction-upload-wizard/reverse-auction-upload-wizard.component';
import { AuthService } from 'app/_services/auth.service';
import { bind } from 'app/_decorators/bind.decorator';
import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class ReverseUploadWizardNetworkPointComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<ReverseProductUploadContext>;

    private INPUT_ADDON: {};
    private tsoFilter: string[];

    constructor(
        private $location: ng.ILocationService,
        private authService: AuthService,
        private networkPointSearchService
    ) {
        this.INPUT_ADDON = this.networkPointSearchService.INPUT_ADDON;
        this.authService.userLoginPromise.promise.then(
            (loggedInUser) => (this.tsoFilter = [loggedInUser.tsoName])
        );
    }

    $onInit() {}

    @bind
    public onNetworkPointSelection(selectedNetworkPoints, isFromQuickfilter) {
        this.wizardCtrl.context.data.selectedNetworkPoint =
            selectedNetworkPoints;
    }

    public cancel(): void {
        this.$location.path('/uploads');
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }

        this.wizardCtrl.next();
        return true;
    }
}

angular.module('app').component('pkpReverseAuctionUploadWizardNetworkPoint', {
    controller: ReverseUploadWizardNetworkPointComponentCtrl,
    template:
        require('app/reverse-auction-upload-wizard/reverse-auction-upload-wizard-network-point.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
